module.exports = __webpack_public_path__ + "4c7deb6554c4a8abafbd5625d5974bfb.png";